import { SMALL_MODAL } from 'consts/modalStyles'
import type { TDatadogErrorLog } from 'utils/datadog/types'

export const JOBS_PAGE_SIZE = 20

export const SEARCH_DEBOUNCE_DELAY_MS = 500

export const GET_JOBS_WITH_FOLDERS_LOG: TDatadogErrorLog = {
  from: 'src/components/AddToJobFolderModal/hooks/useJobsWithFolders.ts',
  name: 'Get Jobs with Folders',
  message: 'Fetch list of all dashboards in a workspace with theirs folders',
}

export const GET_WORKSPACE_COMPANY_PLAN_LOG_ERROR: TDatadogErrorLog = {
  from: 'src/components/AddToJobFolderModal/AddToJobFolderModal.jsx',
  name: 'Get workspace company plan',
  message: 'Failed to fetch workspace company plan for add to folder modal.',
}

export const MODAL_STYLE = {
  ...SMALL_MODAL,
  content: {
    ...SMALL_MODAL.content,
    padding: '0px',
    width: 560,
    height: 717,
    maxHeight: '80%',
  },
}
